import { render, staticRenderFns } from "./HotelCheckout.vue?vue&type=template&id=2edef4aa"
import script from "./HotelCheckout.vue?vue&type=script&lang=js"
export * from "./HotelCheckout.vue?vue&type=script&lang=js"
import style0 from "./HotelCheckout.vue?vue&type=style&index=0&id=2edef4aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports